/**
 * RANGE_SP モジュール
 * - 画面幅が768px以下かどうかを判定し、結果を外部変数に格納
 * - 初期化時に即時判定＆リサイズ時にも再判定を実行
 */
export const RANGE_SP = {
  /**
   * 初期化関数
   * @param {Object} variables - 状態を格納する外部変数オブジェクト
   */
  init(variables) {
    const mq = window.matchMedia('(max-width: 47.99em)')

    // 初期チェック
    this.check(mq, variables)

    // メディアクエリの変更を監視
    mq.addEventListener('change', () => this.check(mq, variables))
  },

  /**
   * メディアクエリの状態を確認して変数に代入
   * @param {MediaQueryList} mq
   * @param {Object} variables
   */
  check(mq, variables) {
    variables.range_sp = mq.matches
  },
}
